<div class="consumption-details">
  <div class="row header">
    <div class="col-6 align-content-start">Type de consommation</div>
    <div class="col-2">Nbre de corresp.</div>
    <div class="col-2">Volume</div>
    <div class="col-2">Montant</div>
  </div>
  @for (consumptionDetails of landLineConsumption.included.french; track consumptionDetails; let index = $index) {
    <div class="row" [ngClass]="{'gris-background': setBackgroundColor(index) == true}">
      <div class="col-6">{{ consumptionDetails.label }}</div>
      <div class="col-2">
        @if (consumptionDetails.unit !== 'ko') {
          <span>
            {{ consumptionDetails.correspondentsNumber }}
          </span>
        }
      </div>
      <div class="col-2">{{ consumptionDetails.consumption }}</div>
      <div class="col-2">{{ consumptionDetails.price.toFixed(2).toString().replace('.', ',') }}€</div>
    </div>
  }
  @for (consumptionDetails of landLineConsumption.included.international; track consumptionDetails) {
    <div class="row">
      <div class="col-6">{{ consumptionDetails.label }}</div>
      <div class="col-2">
        @if (consumptionDetails.unit !== 'ko') {
          <span>
            {{ consumptionDetails.correspondentsNumber }}
          </span>
        }
      </div>
      <div class="col-2">{{ consumptionDetails.consumption }}</div>
      <div class="col-2">{{ consumptionDetails.price.toFixed(2).toString().replace('.', ',') }}€</div>
    </div>
  }
  @for (consumptionDetails of landLineConsumption.included.other; track consumptionDetails) {
    <div class="row">
      <div class="col-6">{{ consumptionDetails.label }}</div>
      <div class="col-2">
        @if (consumptionDetails.unit !== 'ko') {
          <span>
            {{ consumptionDetails.correspondentsNumber }}
          </span>
        }
      </div>
      <div class="col-2">{{ consumptionDetails.consumption }}</div>
      <div class="col-2">{{ consumptionDetails.price.toFixed(2).toString().replace('.', ',') }}€</div>
    </div>
  }
  <div class="row blue-background">
    <div class="col-10">Montant total des communications &nbsp;<span class="font-weight-bold">incluses</span>&nbsp; facturées : </div>
    <div class="col-2 font-weight-bold">{{ landLineConsumption.included.price.toFixed(2).toString().replace('.', ',') }}€</div>
  </div>
  <!-- *************************************** Not included communication *************************************** -->
  @for (consumptionDetails of landLineConsumption.notIncluded.french; track consumptionDetails; let index = $index) {
    <div class="row" [ngClass]="{'gris-background': setBackgroundColor(index) == true}">
      <div class="col-6">{{ consumptionDetails.label }}</div>
      <div class="col-2">
        @if (consumptionDetails.unit !== 'ko') {
          <span>
            {{ consumptionDetails.correspondentsNumber }}
          </span>
        }
      </div>
      <div class="col-2">{{ consumptionDetails.consumption }}</div>
      <div class="col-2">{{ consumptionDetails.price.toFixed(2).toString().replace('.', ',') }}€</div>
    </div>
  }
  @for (consumptionDetails of landLineConsumption.notIncluded.international; track consumptionDetails) {
    <div class="row">
      <div class="col-6">{{ consumptionDetails.label }}</div>
      <div class="col-2">
        @if (consumptionDetails.unit !== 'ko') {
          <span>
            {{ consumptionDetails.correspondentsNumber }}
          </span>
        }
      </div>
      <div class="col-2">{{ consumptionDetails.consumption }}</div>
      <div class="col-2">{{ consumptionDetails.price.toFixed(2).toString().replace('.', ',') }}€</div>
    </div>
  }
  @for (consumptionDetails of landLineConsumption.notIncluded.other; track consumptionDetails) {
    <div class="row">
      <div class="col-6">{{ consumptionDetails.label }}</div>
      <div class="col-2">
        @if (consumptionDetails.unit !== 'ko') {
          <span>
            {{ consumptionDetails.correspondentsNumber }}
          </span>
        }
      </div>
      <div class="col-2">{{ consumptionDetails.consumption }}</div>
      <div class="col-2">{{ consumptionDetails.price.toFixed(2).toString().replace('.', ',') }}€</div>
    </div>
  }
  @for (service of landLineConsumption.services.list; track service) {
    <div class="row">
      <div class="col-6">{{ service.label }}</div>
      <div class="col-2"></div>
      <div class="col-2"></div>
      <div class="col-2">{{ (service.price * service.amount).toFixed(2).toString().replace('.', ',') }}€</div>
    </div>
  }
  @if (landLineConsumption.notIncluded.french.length > 0 || landLineConsumption.notIncluded.international.length > 0 || landLineConsumption.notIncluded.other.length > 0 || landLineConsumption.services.price != 0) {
    <div class="row blue-background">
      <div class="col-9">Montant total des communications &nbsp;<span class="font-weight-bold">NON incluses</span>&nbsp; facturées : </div>
      <div class="col-3 font-weight-bold">{{ (landLineConsumption.notIncluded?.price + landLineConsumption.services.price).toFixed(2).toString().replace('.', ',') }}€</div>
    </div>
  }
</div>
